<template>
<v-card flat class="mt-2 mr-2">
    <v-snackbar v-model="snackbar.active" :color="snackbar.color" :timeout="4000" top >    
        <span> {{snackbar.message}} </span>
        <v-btn text @click="snackbar.active = false">Close</v-btn>
    </v-snackbar>    
    <v-tabs v-model="tab" background-color="#296B74" color="white" dark centered fixed-tabs>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
            <v-icon left>mdi-store-outline</v-icon>
            Sua Loja
        </v-tab>
        <v-tab href="#tab-2">
            <v-icon left>mdi-comment-account-outline</v-icon>
            Seu Atendimento
        </v-tab>
        <v-tab href="#tab-3">
            <v-icon left>mdi-moped</v-icon>
            Sua Entrega
        </v-tab>
        <v-tab href="#tab-4">
            <v-icon left>mdi-cash-usd</v-icon>
            Seus Pagamentos
        </v-tab>        
        <v-tab href="#tab-5">
            <v-icon left>mdi-account-group</v-icon>
            Seu Time
        </v-tab>        
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="1" :value="'tab-1'" >
        <v-card flat>
            <v-card-text>
                <storePage v-model="storeInfo" v-on:loadMessage="loadMessage"/> 
            </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2" :value="'tab-2'" >
        <v-card class="mx-auto">
            <v-card-text>
                <attendPage v-model="attendInfo" v-on:loadMessage="loadMessage"/>
            </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="3" :value="'tab-3'" >
        <v-card class="mx-auto">
            <v-card-text>
                <deliveryPage v-model="deliveryInfo" v-on:loadMessage="loadMessage"/>
            </v-card-text>
        </v-card>        
      </v-tab-item>            
      <v-tab-item :key="4" :value="'tab-4'" >
            <paymentPage v-model="paymentInfo" v-on:loadMessage="loadMessage"/>
      </v-tab-item>   
      <v-tab-item :key="5" :value="'tab-5'" >
            <teamPage v-model="teamInfo" v-on:loadMessage="loadMessage"/>
      </v-tab-item>                 
    </v-tabs-items>    
  </v-card>
</template>

<script>
import storePage from './storePage'
import attendPage from './attendPage'
import deliveryPage from './deliveryPage'
import teamPage from './teamPage'
import paymentPage from './paymentPage'

    export default {
        components: {storePage, attendPage, deliveryPage, teamPage, paymentPage},
        data: () => ({
            snackbar: {
                'active':false,
                'color':'success',
                'message':'Deu Certo'
            },
            rules: {
                required: value => !!value || 'Campo Obrigatório.',
                min: v => v.length >= 8 || 'Min 8 characters',
                minlength: len => v => (v || '').length >= len || `Número de Caractéres Inválido. Mínimo: ${len}`,
                maxlength: len => v => (v || '').length < len || `Número de Caractéres Inválido. Máximo: ${len}`,                
            },            
            items:['ITEM1','ITEM2','ITEM3'],
            tab: "tab-1",    
            tabEnt: "tabEnt-1",
            storeInfo: '',
            attendInfo: '',
            deliveryInfo: '',
            teamInfo: '',
            paymentInfo: ''
        }),
        methods: {
            loadMessage(value){
                this.snackbar = value
            },            
        }
    }
</script>